import {
  FormControl,
  FormGroup,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import { Link } from "react-router-dom";

import configUrls from "../../config/configUrls";
import { Orgao } from "../../types/orgao/Orgao";
import CepInput from "../../components/formControls/CepInput";
import { GridDeleteIcon, GridExpandMoreIcon } from "@mui/x-data-grid";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardContent,
  CardMedia,
  CircularProgress,
  Divider,
  FormControlLabel,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Tooltip,
  styled,
} from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import ProtectedImage from "./ProtectedImage";
import { useOrgaoRoutes } from "../../config/useOrgaoRoutes";

type Props = {
  data: Orgao;
  isdisabled?: boolean;
  isLoading?: boolean;
  handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleCepChange: (newCep: string) => void;
  logo: File | null;
  setLogo: Dispatch<SetStateAction<File | null>>;
};

export function OrgaoForm({
  data,
  isdisabled = false,
  isLoading = false,
  handleSubmit,
  handleChange,
  handleCepChange,
  setLogo,
  logo,
}: Props) {
    const orgaoRoutes=useOrgaoRoutes();
  const [imagemUrl, setImagemUrl] = useState<string | null>(null);
  const baseUrl = `${orgaoRoutes.ORGAO_LOGO}`;

  const convertImageToWebP = (file: File): Promise<File> => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");

        if (!ctx) {
          // Se não conseguir obter o contexto, retorna a imagem original
          resolve(file);
          return;
        }

        ctx.drawImage(img, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            const webpFile = new File(
              [blob],
              file.name.replace(/\.[^/.]+$/, "") + ".webp",
              { type: "image/webp" }
            );
            resolve(webpFile);
          } else {
            // Se a conversão falhar, retorna a imagem original
            resolve(file);
          }
        }, "image/webp");
      };

      img.onerror = () => {
        // Se ocorrer um erro ao carregar a imagem, retorna a imagem original
        resolve(file);
      };
    });
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleFileCapaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      const file = event.target.files[0]; // Armazena apenas o primeiro arquivo
      if (file) {
        convertImageToWebP(file).then((convertedImage) => {
          setLogo(convertedImage);
        });
      }

      //setImagemCapa(file);
      const url = URL.createObjectURL(file); // Cria uma URL para a miniatura
      setImagemUrl(url);
    }
  };
  const handleFileDeleteCapa = () => {
    setImagemUrl(null);
    setLogo(null);
  };

  const handleFileDeleteCapaEdit = () => {
    //  dispatch(atualizarImagemCapa(""));
  };

  return (
    <Box mt={2} p={2}>
      <form onSubmit={handleSubmit} method="POST">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="Nome"
                name="nome"
                disabled={isdisabled}
                onChange={handleChange}
                size="small"
                inputProps={{ maxLength: 255 }}
                value={data.nome}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                required
                label="Abreviatura"
                name="abreviatura"
                disabled={isdisabled}
                onChange={handleChange}
                size="small"
                inputProps={{ maxLength: 10 }}
                value={data.abreviatura}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Descrição"
                name="descricao"
                disabled={isdisabled}
                onChange={handleChange}
                size="small"
                inputProps={{ maxLength: 255 }}
                value={data.descricao}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Endereço"
                name="endereco"
                disabled={isdisabled}
                onChange={handleChange}
                size="small"
                inputProps={{ maxLength: 255 }}
                value={data.endereco}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <FormControl sx={{ width: "50%", marginRight: "10px" }}>
                <TextField
                  label="Número"
                  name="numero"
                  disabled={isdisabled}
                  onChange={handleChange}
                  size="small"
                  inputProps={{ maxLength: 10 }}
                  value={data.numero}
                />
              </FormControl>

              <FormControl sx={{ width: "70%", marginRight: "10px" }}>
                <TextField
                  label="Complemento"
                  name="complemento"
                  disabled={isdisabled}
                  onChange={handleChange}
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  value={data.complemento}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  label="Bairro"
                  name="bairro"
                  disabled={isdisabled}
                  onChange={handleChange}
                  size="small"
                  inputProps={{ maxLength: 50 }}
                  value={data.bairro}
                />
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="space-between">
              <FormControl sx={{ width: "29%", marginRight: "10px" }}>
                <CepInput
                  required={false}
                  label="CEP"
                  name="cep"
                  disabled={isdisabled}
                  handleCepChange={handleCepChange}
                  value={data.cep || ""}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  label="Cidade"
                  name="cidade"
                  disabled={isdisabled}
                  onChange={handleChange}
                  size="small"
                  inputProps={{ maxLength: 100 }}
                  value={data.cidade}
                />
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <TextField
                label="Telefone"
                name="telefone"
                disabled={isdisabled}
                onChange={handleChange}
                size="small"
                inputProps={{ maxLength: 50 }}
                value={data.telefone}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                // disabled={publicacao.id && publicacao.imagem ? true : false}
                startIcon={<CloudUploadIcon />}
                sx={{ textTransform: "none" }} // Adicione esta linha
              >
                Selecione uma logotipo -{" "}
                {logo ? logo.name : "Nenhum selecionado"}
                <VisuallyHiddenInput
                  type="file"
                  onChange={handleFileCapaChange}
                  //multiple
                  accept="image/*" // Aceita apenas imagens e PDFs
                />
              </Button>

              {imagemUrl && (
                <Box
                  mt={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <img
                    src={imagemUrl}
                    alt="Miniatura"
                    style={{ maxWidth: "100%", maxHeight: "150px" }}
                  />
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleFileDeleteCapa}
                    sx={{ mt: 1 }}
                  >
                    <GridDeleteIcon color="secondary" />
                  </Button>
                </Box>
              )}

              <Box display="flex" flexDirection="column" alignItems="center">
                <CardContent>
                  {data.logo && (
                    <>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          justifyContent: "center",
                        }}
                      >
                        <ProtectedImage
                          filename={data.logo}
                          style={{
                            width: "100%", // Tamanho da miniatura, ajustando para a largura total do container
                            height: "auto", // Deixa a altura proporcional à largura da imagem
                            maxHeight: "300px", // Limita a altura máxima da imagem
                            objectFit: "cover", // Garante que a imagem cubra a área sem distorção
                            borderRadius: "8px", // Pode adicionar bordas arredondadas, se desejado
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Sombra ajustada corretamente
                            margin: "0 auto", // Centraliza a imagem
                          }}
                        />
                      </Box>
                    </>
                  )}
                </CardContent>
              </Box>


            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" gap={2}>
              <Button
                type="submit"
                variant="contained"
                color="secondary"
                disabled={isdisabled}
              >
                {isLoading ? <CircularProgress size={24} /> : "Gravar"}
              </Button>

              <Button
                variant="contained"
                component={Link}
                to={orgaoRoutes.ORGAO_LIST}
              >
                Voltar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
}
